import React, { useState, useRef, useEffect } from "react";
import LoadingSpinner from "../LoadingSpinner";
import { fetchReCaptchaToken } from "../Guard";
import Types from "prop-types";

export const CSRF_QUERY_PARAM = "csrf";
export const CSRF_SESSION_STORAGE_FIELD = "idp." + CSRF_QUERY_PARAM;

function RedirectToLogin(props) {
  const { fieldName, value, csrf, rememberMe } = props;
  const [recaptcha, setRecaptcha] = useState("");
  const form = useRef(null);

  useEffect(() => {
    fetchReCaptchaToken("signup_redirect_to_login").then((recaptcha) => {
      setRecaptcha(recaptcha);
      form.current.submit();
    });
  }, [form]);

  return (
    <div>
      <LoadingSpinner />
      <form
        action={`${process.env.REACT_APP_IDENTITY_HOST}/login`}
        method="post"
        ref={form}
      >
        <input
          name="g-recaptcha-response"
          type="hidden"
          value={recaptcha}
          readOnly
        />
        <input name={fieldName} type="hidden" value={value} readOnly />
        <input name="_csrf" hidden={true} value={csrf} readOnly />
        <input name="remember" hidden={true} value={rememberMe} readOnly />
      </form>
    </div>
  );
}

RedirectToLogin.propTypes = {
  fieldName: Types.string.isRequired,
  value: Types.string.isRequired,
  csrf: Types.string.isRequired,
  rememberMe: Types.bool.isRequired,
};

export default RedirectToLogin;
